import '/app/brewery-packages/content/content-editor-plugin-paragraph/src/Paragraph.css-raw';
export default {
  "paragraph": "employees-21b62107-paragraph-WaWZGW"
};